//GeneratorFlag:[NoChange]
import ext from './en-ext.js'
export default {
	"name":"messenger",
	"ext": ext,
	"layout":{
//GeneratorFlag:[NewLayout]
	},
	'room':'room',
	'roomCreate':'Create New room',
	'roomLayout':'room',

}